import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { PlantingSitesShellComponent } from '../planting-sites-shell.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PlantingSiteDto } from '../../../../../models/trofaco/plantingSiteDto';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-sites-shell-frontend',
    templateUrl: './sites-shell-frontend.component.html',
    styleUrls: ['./sites-shell-frontend.component.css']
})
export class SitesShellFrontendComponent extends PlantingSitesShellComponent implements OnDestroy {
    siteCount = 0;
    isGridPage = true;
    isNewest: string;

    constructor(router: Router, route: ActivatedRoute, private renderer: Renderer2, userService: UserService) {
        super(router, route, userService);
    }

    toggleFilterActive() {
        this.filterActive = !this.filterActive;
        if (this.filterActive) {
            this.renderer.addClass(document.body, 'filter-active');
        } else {
            this.renderer.removeClass(document.body, 'filter-active');
        }
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.route.firstChild)
            this.isGridPage = this.route.firstChild.snapshot.data.isGrid;
        this.router.events
            .pipe(
                filter(e => (e instanceof NavigationEnd)),
                switchMap(() => this.route.firstChild ? this.route.firstChild.data : of({})),
                takeUntil(this.onDestroy$)
            )
            .subscribe(data => this.isGridPage = data.isGrid);
        this.plantingSitesChange.subscribe(sites => this.siteCount = sites.length);
        let params = { ...this.route.snapshot.queryParams };
        this.isNewest = params.sort || 'new';
    }

    filterActive = false;

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, 'filter-active');
    }

    quickSearch(site: PlantingSiteDto, searchText: string | null): boolean {
        if (!searchText && searchText !== '0') return true;
        let lowerSearchText = searchText.toLowerCase();
        if (site.title && site.title.toLowerCase().includes(lowerSearchText)) return true;
        if (!site.certificates) return false;
        return site.certificates.some(cert => {
            if (cert.customerName && cert.customerName.toLowerCase().includes(lowerSearchText)) return true;
            if (cert.customerCode && cert.customerCode.toLowerCase().includes(lowerSearchText)) return true;
            if (cert.code && cert.code.toLowerCase().includes(lowerSearchText)) return true;
            return false;
        });
    }
}
